exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#spacerxsm{padding-top:1.5rem}#instrHeader{margin:0 auto;border:0;background-color:grey;padding-left:3.5rem}#instrHeader div{padding:.5rem;float:left;background-color:grey}#instrHeader-left{width:56rem;vertical-align:left;text-align:center;font-size:14pt;float:left}#woHeader div{padding:1rem;float:left;background-color:grey}#siAdmission{margin:2rem 3rem;border:0;background-color:#70706e;padding-left:.6rem}#siAdmission-left{vertical-align:left;text-align:left;float:left;font-weight:700;width:67rem}#siInstruction{margin:17.5rem 3rem;border:0;background-color:#70706e;padding-left:.6rem}#instruction-text{vertical-align:left;text-align:left;float:left}.Button{font-family:Verdana,Tahoma,Arial;width:6rem}#woButton{margin:16rem -45rem;vertical-align:left;text-align:left;float:left;padding-left:10rem}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/specialInstruction/specialInstruction.component.scss
// module id = ./src/app/specialInstruction/specialInstruction.component.scss
// module chunks = app